export enum PaymentSberPaycStatusType {
    Created = 'Created',
    NotStarted = 'NotStarted',
    InProgress = 'InProgress',
    Succeed = 'Succeed',
    Failed = 'Failed'
}
